import { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { getContent } from "../lib/api";
import { HandHeart } from "lucide-react";

const CATS = [
  { key: "wake",   label: "wake" },
  { key: "meal",   label: "meal" },
  { key: "travel", label: "travel" },
  { key: "trials", label: "trials" },
  { key: "prayer", label: "prayer" }
];

export default function Duas() {
  const { t } = useApp();
  const [data, setData] = useState(null);
  const [cat, setCat] = useState("wake");

  useEffect(() => { getContent("duas").then(setData); }, []);

  return (
    <div className="space-y-6 fade-in" data-testid="duas-page">
      <header className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-2xl bg-nour-primary text-white flex items-center justify-center"><HandHeart className="w-6 h-6" /></div>
        <div>
          <h1 className="font-heading text-2xl font-bold">{t.duas}</h1>
          <p className="text-sm text-nour-text2">Invocations authentiques</p>
        </div>
      </header>

      <div className="flex gap-2 overflow-x-auto no-scrollbar" data-testid="duas-tabs">
        {CATS.map(c => (
          <button
            key={c.key}
            onClick={() => setCat(c.key)}
            data-testid={`dua-tab-${c.key}`}
            className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition ${
              cat === c.key ? "bg-nour-primary text-white" : "bg-white border border-[rgba(29,158,117,0.2)] text-nour-text2"
            }`}
          >
            {t[c.label]}
          </button>
        ))}
      </div>

      <div className="space-y-3" data-testid="duas-list">
        {data?.[cat]?.map(d => (
          <article key={d.id} className="nour-card p-5" data-testid={`dua-${d.id}`}>
            <div className="font-arabic-quran text-2xl text-right text-nour-primary mb-3" dir="rtl">{d.ar}</div>
            <div className="text-sm text-nour-text2 italic mb-1">{d.translit}</div>
            <div className="text-base">{d.fr}</div>
            <div className="text-xs text-nour-text2 mt-2">— {d.source}</div>
          </article>
        ))}
      </div>
    </div>
  );
}
